export default __webpack_public_path__ + "static/media/projTrack7Full.b74f705a.png";